import { render } from "./LabelDetail.vue?vue&type=template&id=6410398c&scoped=true"
import script from "./LabelDetail.vue?vue&type=script&lang=js"
export * from "./LabelDetail.vue?vue&type=script&lang=js"

import "./LabelDetail.vue?vue&type=style&index=0&id=6410398c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6410398c"]])

export default __exports__